(function() {
    window.c24.lp.ac.kfzsb = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('kfzsb');

            window.c24.lp.ac.addQTip({
                acType: 'kfzsb',
                hoverElement: '.mod24ac .checkbox',
                toolTipChild: '.js24Tooltip',
                arrowPosition: 'top center',
                parentPosition: 'bottom center',
                hideDelay: 0,
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.kfzsb.init();
    });
})();
